import React from 'react'
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
//Components
import FlexContainer from '../common/FlexContainer';
//Imágenes
import heroImage from '../../assets/images/RegisterHero.png';

export default function AuthLayout({ children }) {
    return (
        <FlexContainer flexDirection='row' justifyContent='space-between' backgroundColor='var(--color-azul-claro)' alignItems='center' textAlign='left'>
            <Hero>
                <img src={heroImage} alt='HeroImage'></img>
            </Hero>
            <Outlet></Outlet>
        </FlexContainer>
    )
}

const Hero = styled.div`
    align-self: flex-end;
    width: 60%;
    img{
        width: 100%;
    }
`;
